import React, { useEffect, useState } from 'react';

const InitialApprovalPopup = ({ certificate, onClose, onSubmit }) => {
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [isApproved, setIsApproved] = useState(false);
  const [hasComments, setHasComments] = useState(false);

  useEffect(() => {
    // Check if certificate is already approved
    const approvalStatus = getValue(certificate.initial_ph_approval);
    if (approvalStatus === 'Approved'){
    setIsApproved(approvalStatus === 'Approved');
    }else{
      setIsApproved(approvalStatus === 'Rejected')
    }
    
    // Check if comments exist
    const existingComments = getValue(certificate.comments);
    setHasComments(!!existingComments);
    setComments(existingComments);
  }, [certificate]);

  const getValue = (field, defaultValue = '') => {
    if (!field) return defaultValue;
    if (typeof field === 'string') return field;
    if (typeof field === 'number' || typeof field === 'boolean') return field.toString();
    return field.String || field.Bool || field.Int64 || field.Float64 || defaultValue;
  };

  const handleSubmit = async (status) => {
    if (status === 'Rejected' && !comments.trim()) {
      setError('Please provide comments for rejection');
      return;
    }

    setIsSubmitting(true);
    setError('');

    const payload = {
      action_type: "initial_ph_approval",
      request_id: certificate.request_id,
      emp_id: certificate.emp_id,
      approval_status: status,
      comments: comments.trim() || (status === 'Approved' ? 'The request was reviewed and approved.' : '')
    };

    try {
      await onSubmit(payload);
      onClose(); 
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  return (
    <div className="modal fade show d-block"
    style={{
      display: 'block',
      backgroundColor: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(2px)'
  }}
     >
      <div className="modal-dialog certification-modal approval-modal-width">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">
              Certification Approval -{getValue(certificate.emp_name)}
            </h6>
            <button 
              type="button" 
              className="btn-close font-12" 
              aria-label="Close"
              onClick={onClose}
              disabled={isSubmitting}
            />
          </div>
          
          <div className="modal-body">
            <div className="row">
              <div className="col-md-8 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Certification Name
                </label>
                <div className="d-flex justify-content-start align-items-center">
                  <p className="font-12 semibold-text">{getValue(certificate.certificate_name)}</p>
                  {getValue(certificate.client_dependency) &&(
                    <span className="client-badge ms-2">Client</span>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Provider
                </label>
                <p className="font-12 semibold-text">{getValue(certificate.provider)}</p>
              </div>

              <div className="col-md-12 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Comments
                </label>
                {hasComments ? (
                  <p className="font-12 semibold-text">
                    {comments || 'No comments yet.'}
                  </p>
                ) : (
                  <textarea 
                    className={`form-control font-12 comment-box ${error ? 'border-danger' : ''}`}
                    placeholder="Type your comments here..." 
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    disabled={isApproved}
                  />
                )}
                {error && <small className="text-danger">{error}</small>}
              </div>
            </div>
          </div>

          {!isApproved && (

          <div className="modal-footer border-0">
            <div className="d-flex justify-content-end w-100">
              <button 
                className="btn negative-btn me-2 font-12 semibold-text"
                onClick={() => handleSubmit('Rejected')}
                disabled={isSubmitting}
              >
                Reject
              </button>
              <button 
                className="btn succes-btn font-12 semibold-text"
                onClick={() => handleSubmit('Approved')}
                disabled={isSubmitting}
              >
                Approve
              </button>
            </div>
          </div>

)}
        </div>
      </div>
    </div>
  );
};

export default InitialApprovalPopup;